import styled from 'styled-components';
export const Container = styled.div`
  width: 100%;
  min-height: ${_ref => {
  let {
    minHeight
  } = _ref;
  return minHeight;
}}px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  opacity: ${_ref2 => {
  let {
    disabled
  } = _ref2;
  return disabled ? 0.3 : 1;
}};
`;
export const LabelContainer = styled.label`
  ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.fonts.labelSM;
}}
  color: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.neutralL5;
}};
  margin-bottom: 8px;
  width: fit-content;
`;